export default "__VITE_ASSET__DGkVeZp8__"